// extracted by mini-css-extract-plugin
export default {"backBtn":"D2kpigh5rztrtndZ7P8T"};